import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

interface LegalSection {
    heading: string;
    body: string;
}

interface LegalPageLayoutProps {
    // i18n key prefix for this page, e.g. "legalNotice" -- looks up
    // `${nsKey}.title`, an optional `${nsKey}.intro`, and `${nsKey}.sections`
    // (an array of { heading, body }, via i18next's returnObjects).
    nsKey: string;
}

function LegalPageLayout({ nsKey }: LegalPageLayoutProps) {
    const { t } = useTranslation();
    const intro = t(`${nsKey}.intro`, { defaultValue: '' });
    const sections = t(`${nsKey}.sections`, { returnObjects: true }) as LegalSection[];

    return (
        <Container maxWidth="md" sx={{ py: 6, textAlign: 'left' }}>
            <Typography variant="h3" gutterBottom>{t(`${nsKey}.title`)}</Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
                {t('legalCommon.lastUpdated', { date: t(`${nsKey}.lastUpdated`) })}
            </Typography>

            {intro && (
                <Typography variant="body1" sx={{ mt: 3, whiteSpace: 'pre-line' }}>
                    {intro}
                </Typography>
            )}

            {sections.map((section, index) => (
                <Box key={index} sx={{ mt: 4 }}>
                    <Typography variant="h6" gutterBottom>{section.heading}</Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                        {section.body}
                    </Typography>
                </Box>
            ))}
        </Container>
    );
}

export default LegalPageLayout;
